module.exports = __webpack_public_path__ + "img/pr.8eb64a78.svg";